import { Pressable, StyleSheet, View } from 'react-native';

import { Text } from '@/components/Text';
import { colors, radii, spacing } from '@/constants/theme';

export type SocialFilter = 'all' | 'in_progress' | 'completed';

const FILTERS: { key: SocialFilter; label: string }[] = [
  { key: 'all', label: 'All' },
  { key: 'in_progress', label: 'In progress' },
  { key: 'completed', label: 'Completed' },
];

export type SocialFilterChipsProps = {
  value: SocialFilter;
  onChange: (filter: SocialFilter) => void;
  testID?: string;
};

/** The Create tab's filter pills (Figma "Create" frame): the chosen one is Deep Green. */
export function SocialFilterChips({ value, onChange, testID }: SocialFilterChipsProps) {
  return (
    <View style={styles.row} testID={testID}>
      {FILTERS.map(({ key, label }) => {
        const selected = key === value;
        return (
          <Pressable
            key={key}
            onPress={() => onChange(key)}
            hitSlop={CHIP_HIT_SLOP}
            accessibilityRole="button"
            accessibilityLabel={`Show ${label.toLowerCase()} deals`}
            accessibilityState={{ selected }}
            style={({ pressed }) => [styles.chip, selected && styles.selected, pressed && styles.pressed]}
            testID={testID ? `${testID}-${key}` : undefined}
          >
            <Text variant="caption" color={selected ? 'frost' : 'textMuted'}>
              {label}
            </Text>
          </Pressable>
        );
      })}
    </View>
  );
}

// A 34pt pill with 5pt above and below reaches the 44pt touch target.
const CHIP_HIT_SLOP = { top: 5, bottom: 5 };

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    gap: spacing.sm,
  },
  chip: {
    minHeight: 34,
    justifyContent: 'center',
    paddingHorizontal: spacing.base,
    borderRadius: radii.full,
    backgroundColor: colors.track,
  },
  selected: {
    backgroundColor: colors.deepGreen,
  },
  pressed: {
    opacity: 0.6,
  },
});
